import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateVRFIndoor } from '../../redux/vrf/vrf_indoor_actions';

const mapStateToProps = state => ({
  isDuplicating: state.vrfIndoor.isDuplicating,
  errorMessage: state.vrfIndoor.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateVRFIndoor(id, name)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/VRFIndoorDuplicateModal.js